import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { WhoWeArePage } from './pages/WhoWeAre';
import { SolutionsPage } from './pages/Solutions';
import { IndustriesPage } from './pages/Industries';
import { PricingPage } from './pages/Pricing';
import { ResourcesPage } from './pages/Resources';
import { ContactPage } from './pages/Contact';
import { LoginPage } from './pages/Login';
import { SignupPage } from './pages/Signup';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31agnwnhawdix">
      <ScrollToTop data-id="element-1" data-mp="31ayqs2ygxpzt" />
      <Routes data-id="element-2" data-mp="31bianp7oiogh">
        <Route path="/" element={<LandingPage data-id="element-4" data-mp="31cjk5p91r2w3" />} data-id="element-3" data-mp="31c1j8fbfw0hu" />
        <Route path="/who-we-are" element={<WhoWeArePage data-id="element-6" data-mp="2wiffjcn976y6" />} data-id="element-5" data-mp="2wjgq7g0cxrfd" />
        <Route path="/solutions" element={<SolutionsPage data-id="element-8" data-mp="28tw4ipctkg2e" />} data-id="element-7" data-mp="2wi5mthatqlos" />
        <Route path="/industries" element={<IndustriesPage data-id="element-10" data-mp="28s2xva27hvue" />} data-id="element-9" data-mp="28t4l0cwhy8sh" />
        <Route path="/pricing" element={<PricingPage data-id="element-12" data-mp="23ujjma5idj2g" />} data-id="element-11" data-mp="23vuokdaowwv5" />
        <Route path="/resources" element={<ResourcesPage data-id="element-14" data-mp="3ik7eyd5x05p2" />} data-id="element-13" data-mp="23t8hsfvmildz" />
        <Route path="/contact" element={<ContactPage data-id="element-16" data-mp="3ijpdn24eb1aa" />} data-id="element-15" data-mp="3iiwfgpji5k3r" />
        <Route path="/login" element={<LoginPage data-id="element-18" data-mp="3mkrc3gqhn9b7" />} data-id="element-17" data-mp="3mlj82snzz920" />
        <Route path="/signup" element={<SignupPage data-id="element-20" data-mp="3mj6hjr46bqdc" />} data-id="element-19" data-mp="3mjzsl4a6121a" />
      </Routes>
    </BrowserRouter>;
}